import React from 'react';
import {downloadExcel, printPDF} from '../../utils/printUtils';

const headers = {
  name: 'Drug Name',
  dosage: 'Dosage',
  category: 'Category',
  generic_name: 'Generic Medicine',
  quantity: 'Quantity',
  vendor: 'Vendor',
  order_date: 'Order Date',
  manufactured_date: 'MFG Date',
  expiry_date: 'EXP Date'
};

const Header = ({title, cb, tableData}) => {
  const handlePrintPdf = () => {
    printPDF({title, headers, data: tableData});
  };
  const handleDownload = () => {
    downloadExcel({title, headers, data: tableData});
  };

  return (
    <div className='patient-header'>
      <div className='row'>
        <div className='col'>
          <h3 className='page-title'>{title}</h3>
          <ul className='breadcrumb'>
            <li className='breadcrumb-item'>
              <a href='/' style={{textDecoration: 'none', color: 'black'}}>
                Dashboard
              </a>
            </li>
            <li className='breadcrumb-item active'>{title}</li>
          </ul>
        </div>
      </div>
      <div className='add_btn' style={{display: 'flex', gap: '10px'}}>
        <button onClick={cb} className='btn_1'>
          Add
        </button>
        <button onClick={handlePrintPdf} className='btn_1'>
          Print
        </button>
        <button onClick={handleDownload} className='btn_1'>
          Download
        </button>
      </div>
    </div>
  );
};

export default Header;
